import React, { Component } from "react";
import { StoryElement, ImageGalleryElement, ResponsiveImage } from "@quintype/components";
import "./styles.m.css";
import "./story-elements.scss";
import Carousel from "../../atoms/carousel";
import { number, array } from "prop-types";
import LightBox from "../../molecules/lightbox";
import { DfpAd } from "../../atoms/dfp-ad";
import { Download } from "../../atoms/icons/download";
import get from "lodash/get";

class StoryCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      galleryItemIndex: 0,
      showPopup: {}
    };
    this.galleryItems = [];
    this.togglePopup = this.togglePopup.bind(this);
  }

  togglePopup(id, isPopupOpen, index = 0) {
    this.setState({
      showPopup: {
        [id]: isPopupOpen
      },
      galleryItemIndex: index
    });
  }

  render() {
    const { card, story } = this.props;
    const CAROUSEL_OPTIONS = {
      type: "carousel",
      autoplay: 0
    };
    const attachmentValue = card["story-elements"].some(element => element.type === "file");
    const fileName = attachmentValue ? card["story-elements"][0].text : "";

    return (
      <div className="story-page-card">
        {card["story-elements"] &&
          !attachmentValue &&
          card["story-elements"].map((element, index) => {
            const alsoReadValue = element.subtype === "also-read";

            switch (element.subtype) {
              case "image-gallery":
                if (element.metadata.type === "gallery") {
                  return (
                    <div key={element.id}>
                      {element.type === "composite" ? (
                        <ImageGalleryElement
                          story={story}
                          element={element}
                          imageAspectRatio={[1, 1]}
                          onClickHandler={index => this.togglePopup(element.id, true, index)}
                        />
                      ) : (
                        <StoryElement story={story} element={element} />
                      )}
                      <div>
                        {this.state.showPopup[element.id] ? (
                          <LightBox
                            element={element["story-elements"][this.state.galleryItemIndex]}
                            closePopup={() => this.togglePopup(element.id, false)}
                          />
                        ) : null}
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <Carousel
                      options={CAROUSEL_OPTIONS}
                      carouselName={"carousel-" + element.id}
                      styleName="story-page-carousel"
                      renderBottomCenterControls={null}
                    >
                      {element["story-elements"] &&
                        element["story-elements"].map(image => (
                          <ResponsiveImage
                            key={image.id}
                            slug={image["image-s3-key"]}
                            metadata={image["image-metadata"]}
                            alt="image"
                            aspectRatio={[16, 9]}
                            defaultWidth={480}
                            widths={[250, 850]}
                            sizes="(max-width: 500px) 98vw, (max-width: 768px) 48vw, 23vw"
                            imgParams={{ auto: ["format", "compress"] }}
                            eager={true}
                          />
                        ))}
                    </Carousel>
                  );
                }
              default:
                if (this.props.excludeElementId !== element.id && !alsoReadValue) {
                  return (
                    <div>
                      <StoryElement story={story} element={element} />
                      {index === 2 && (
                        <div styleName="inside-story-ad">
                          <DfpAd adtype="instoryad" />
                        </div>
                      )}
                    </div>
                  );
                } else if (this.props.excludeElementId !== element.id && alsoReadValue) {
                  const headline = element.metadata["linked-story"].headline;
                  const linkedStories = get(story, ["linked-stories"]);
                  const linkedStoryId = get(element, ["metadata", "linked-story-id"]);
                  const linkedStorySlug = get(linkedStories, [linkedStoryId, "slug"]);

                  return (
                    <div styleName="also-read-container">
                      <span styleName="also-read">Also Read : </span>
                      <a href={linkedStorySlug} target="_blank" rel="noopener noreferrer" styleName="also-read-title">
                        {headline}
                      </a>
                    </div>
                  );
                } else {
                  return null;
                }
            }
          })}
        {card["story-elements"].length > 1 &&
          attachmentValue && (
            <div styleName="attachment-element">
              <span styleName="filename">{fileName}</span>
              <a
                styleName="download-button"
                href={card["story-elements"][1].url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span styleName="download-icon">
                  <Download color="white" width="10" height="10" />
                </span>
                <span styleName="download-name">download</span>
              </a>
            </div>
          )}
      </div>
    );
  }
}

StoryCard.propTypes = { excludeElementId: number, story: array, card: array };

export { StoryCard };
